import React, { useState } from "react";
import { CARD_STYLE } from "../../../../constants/styles";
import { GREY_GRADIENT_PANEL_BACKGROUND } from "../../../../constants/styles";
import {ADMIN_PANEL_BACKGROUND_COLOR } from "../../../../constants/styles";

export default function QuestionnaireSchedulingModal({ open, onClose, onSave }) {

  const [schedule, setSchedule] = useState({
    frequency: "QUARTERLY",
    startDate: "",
    endDate: "",
    daysToComplete: 7,
    autoReissue: false
  });

  if (!open) return null;

  const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.35)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999
  };

  const modalStyle = {
    ...CARD_STYLE,
    width: "520px",
    padding: "0",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
	background:ADMIN_PANEL_BACKGROUND_COLOR
  };

  const headerStyle = {
    padding: "14px 20px",
    borderBottom: "1px solid #ddd",
    fontWeight: "600",
    fontSize: "14px",
    background: GREY_GRADIENT_PANEL_BACKGROUND
  };

  const bodyStyle = {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  };

  const footerStyle = {
    padding: "12px 20px",
    borderTop: "1px solid #ddd",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    background: GREY_GRADIENT_PANEL_BACKGROUND
  };

  const labelStyle = {
    fontSize: "12px",
    fontWeight: "600"
  };

  const inputStyle = {
    padding: "6px 8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "12px",
    width: "calc(100% - 20px)",
	background:ADMIN_PANEL_BACKGROUND_COLOR
  };

  const buttonStyle = {
    padding: "6px 14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "linear-gradient(180deg, #f4f6f8, #e6e8eb)",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "600"
  };

  const handleSave = () => {
    onSave(schedule);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>

        {/* HEADER */}
        <div style={headerStyle}>
          Questionnaire Scheduling
        </div>

        {/* BODY */}
        <div style={bodyStyle}>

          {/* FREQUENCY */}
          <div>
            <div style={labelStyle}>Frequency</div>
            <select
              value={schedule.frequency}
              onChange={(e) => setSchedule({ ...schedule, frequency: e.target.value })}
              style={inputStyle}
            >
              <option value="ONCE">Once</option>
              <option value="DAILY">Daily</option>
              <option value="WEEKLY">Weekly</option>
              <option value="MONTHLY">Monthly</option>
              <option value="QUARTERLY">Quarterly</option>
              <option value="YEARLY">Yearly</option>
            </select>
          </div>

          {/* START DATE */}
          <div>
            <div style={labelStyle}>Start Date</div>
            <input
              type="date"
              value={schedule.startDate}
              onChange={(e) => setSchedule({ ...schedule, startDate: e.target.value })}
              style={inputStyle}
            />
          </div>

          {/* END DATE */}
          <div>
            <div style={labelStyle}>End Date (optional)</div>
            <input
              type="date"
              value={schedule.endDate}
              onChange={(e) => setSchedule({ ...schedule, endDate: e.target.value })}
              style={inputStyle}
            />
          </div>

          {/* COMPLETION WINDOW */}
          <div>
            <div style={labelStyle}>Days to Complete</div>
            <input
              type="number"
              min={1}
              value={schedule.daysToComplete}
              onChange={(e) => setSchedule({ ...schedule, daysToComplete: e.target.value })}
              style={inputStyle}
            />
          </div>

          {/* AUTO REISSUE */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="checkbox"
              checked={schedule.autoReissue}
              onChange={(e) => setSchedule({ ...schedule, autoReissue: e.target.checked })}
            />
            <div style={{ fontSize: "12px" }}>
              Automatically re-issue if not completed
            </div>
          </div>

        </div>

        {/* FOOTER */}
        <div style={footerStyle}>
          <button style={buttonStyle} onClick={onClose}>Cancel</button>
          <button style={buttonStyle} onClick={handleSave}>Save Schedule</button>
        </div>

      </div>
    </div>
  );
}
